import Constant from '@/const';
import axios from 'axios';

const putBed = async (id, payload) => {
  try {
    const response = await axios.put(
      Constant.apiUrl.concat(`/master/bed/${id}`),
      payload,
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default putBed;
